import { render, staticRenderFns } from "./Item.vue?vue&type=template&id=cd8c1fd4&scoped=true"
import script from "./Item.vue?vue&type=script&lang=ts"
export * from "./Item.vue?vue&type=script&lang=ts"
import style0 from "./Item.vue?vue&type=style&index=0&id=cd8c1fd4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd8c1fd4",
  null
  
)

export default component.exports